import { useState } from "react";
import { certificates } from "../../../mocks/home";

export default function Certificates() {
  const [open, setOpen] = useState(false);

  return (
    <section id="guven" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
              Güven
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              MUTFAĞIMIZ BELGELİ,
              <br />
              ÜRETİMİMİZ DENETİMLİ.
            </h2>
            <p className="mt-5 text-foreground-600 leading-relaxed">
              Üretim süreçlerimiz belgeli ve denetimli olarak yürütülür.
              Aşağıdaki belgeler yalnızca gerçek belgeler doğrulandığında
              görüntülenir.
            </p>
            <button
              onClick={() => setOpen(true)}
              className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              BELGELERİ İNCELE
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
            {certificates.map((cert) => (
              <div
                key={cert.id}
                className="flex items-center gap-3 bg-background-50 border border-background-200 rounded-lg px-4 py-4"
              >
                <div className="w-11 h-11 rounded-lg bg-accent-100 text-accent-900 flex items-center justify-center shrink-0">
                  <i className={`${cert.icon} text-xl`}></i>
                </div>
                <span className="text-sm font-semibold text-foreground-800 leading-snug">
                  {cert.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-foreground-950/50"
            onClick={() => setOpen(false)}
          ></div>
          <div className="relative bg-background-50 rounded-lg max-w-lg w-full p-6 md:p-8 animate-fade-up">
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 w-9 h-9 rounded-full bg-background-100 text-foreground-700 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="Kapat"
            >
              <i className="ri-close-line text-lg"></i>
            </button>
            <h3 className="font-heading text-2xl font-bold text-foreground-950">
              Belgelerimiz
            </h3>
            <p className="mt-2 text-sm text-foreground-500">
              Gerçek belge görüntüleri doğrulandığında burada büyük olarak
              gösterilecektir.
            </p>
            <ul className="mt-5 space-y-3">
              {certificates.map((cert) => (
                <li
                  key={cert.id}
                  className="flex items-center gap-3 border border-background-200 rounded-lg px-4 py-3"
                >
                  <i className={`${cert.icon} text-primary-600 text-xl`}></i>
                  <span className="text-sm font-semibold text-foreground-800">
                    {cert.name}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
}